import type { Client } from '@src/clients/domain/Client';
import type { CollapseListener } from '@src/orders/CollapseListener';
import { EditOrderCollapsible } from '@src/orders/EditOrderCollapsible';
import type { FormEntries } from '@src/orders/FormEntries';
import { useSectionError } from '@src/orders/hooks/useSectionError';
import { ControllerFormTextInput } from '@src/orders/PermitFormSections/ControllerFormTextInput';
import { PONumberField } from '@src/permitField/PONumberField';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  client: Client;
} & CollapseListener;

export const PONumberSection = ({
  client,
  collapseEventName,
  uncollapseEventName,
}: Props) => {
  const { t } = useTranslation();
  const { sectionInError } = useSectionError([PONumberField.fieldName]);
  const { control } =
    useFormContext<FormEntries<[typeof PONumberField.fieldName]>>();

  if (!client.requirePO) {
    return null;
  }

  return (
    <EditOrderCollapsible
      title={t('PONumber')}
      collapseEventName={collapseEventName}
      uncollapseEventName={uncollapseEventName}
      inError={sectionInError}
    >
      <ControllerFormTextInput
        control={control}
        fieldName={PONumberField.fieldName}
      />
    </EditOrderCollapsible>
  );
};
